import {alpha} from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  50: '#F2F2F2',
  100: '#E6E6E6',
  200: '#CCCCCC',
  300: '#B3B3B3',
  400: '#999999',
  500: '#666666',
  600: '#4D4D4D',
  700: '#333333',
  800: '#1A1A1A',
  900: '#000000',
  1000: '#0D0D0D',
};


const white = {
  0: '#FFFFFF',
  100: '#F8F8F8',
  200: 'rgba(255, 255, 255, 0.20)',
  300: '#DFE3E8',
  400: 'rgba(255, 255, 255, 0.40)',
  500: '#919EAB',
  600: 'rgba(255, 255, 255, 0.60)',
  700: '#454F5B',
  800: 'rgba(255, 255, 255, 0.80)',
  900: '#FFFFFF',
};

const PRIMARY = {
  lighter: '#FFDCCC', // Более светлый оттенок
  light: '#FF9666',   // Светлый оттенок
  main: '#FF5101',    // Основной цвет
  dark: '#993000',    // Темный оттенок
    darker: '#331000',  // Самый темный оттенок
  contrastText: '#fff', // Цвет текста для контраста
};

const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#84A9FF',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#D8FFCC',
  light: '#8AFF66',
  main: '#2DC300',
  dark: '#249900',
  darker: '#0C3300',
  contrastText: GREY[0],
};

const WARNING = {
  lighter: '#FFB999',
  light: '#FF9666',
  main: '#FF5101',
  dark: '#993000',
  darker: '#662000',
  contrastText: GREY[0],
};

const ERROR = {
  lighter: '#FECDCD',
  light: '#FD6868',
  main: '#C70202',
  dark: '#970202',
  darker: '#320101',
  contrastText: '#fff',
};

const LIGHT = {
  lighter: '#fff3f3',
  light: '#fff7f7',
  main: '#333',
  dark: '#939393',
  darker: '#676767',
  contrastText: '#fff',
};

const CHART = {
  lighter: '#fff3f3',
  light: '#D3FCD2',
  main: '#118D57',
  dark: '#B71D18',
  darker: '#FF5630',
  contrastText: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  light: LIGHT,
  chart: CHART,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  white: white,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[900],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: '#fff',
    default: GREY[900],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
